module.exports = "<app-sesion-alarma-renovar\r\n    kd-modal=\"$ctrl.notificacion\"\r\n    token=\"$ctrl.token\"></app-sesion-alarma-renovar>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/sesion/components/alarma/template.html
// module id = 128
// module chunks = 0